import { MediaEntityType } from '@ancon/wildcat-types'

import getMediaImageCdnUrl from '../../app/utils/getMediaImageCdnUrl'

export default function getProductImageUrl(
  tenantId: string,
  imageId: string,
  productId: string,
  cacheBuster: string,
): string {
  const url = getMediaImageCdnUrl(
    tenantId,
    imageId,
    MediaEntityType.Product,
    productId,
  )

  return `${url}?v=${cacheBuster}`
}
